export class MapHelper {
   
    public drawingManager: any;
    
    initDrawingManager(map: any) {
        let polyOptions: any = {
          drawingControl: false,
          drawingControlOptions: {
            drawingModes: ["polygon"],
            position: google.maps.ControlPosition.LEFT_BOTTOM,
            class: 'drawing-manager'
          },
          polygonOptions: {
            draggable: true,
            editable: true,
            visible: true,
            strokeColor: '#7652e9',
            fillColor: '#7652e9',
            fillOpacity: 0.35,
            strokeWeight: 2
          },
        };
    
        this.drawingManager = new google.maps.drawing.DrawingManager(polyOptions);
        this.drawingManager.setMap(map);
        return this.drawingManager;
    }   

    createWithoutMapMarker(lat, lng, properties) {

      const marker = new google.maps.Marker({
        icon: properties?.icon || '',
        title: properties.title || '',
        position: new google.maps.LatLng(lat, lng),
        visible: false
      });
      return marker;
    }

    removeMarkersFromMap(markers) {
      if (markers?.length) {
        markers.forEach(mark => mark.setMap(null));
      }
      return [];
    }

    setMarkerVisibility(markers, visible) {
      for (const m of markers) {
        m.setVisible(visible);
      }
    }   
}